import script from "./projects-table.vue?vue&type=script&setup=true&lang=js"
export * from "./projects-table.vue?vue&type=script&setup=true&lang=js"

import "./projects-table.vue?vue&type=style&index=0&id=5f6dc4c9&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f6dc4c9"]])

export default __exports__